import fileApi from '@/apis/file-api';

export async function fetchFileObjectUrl(token, fileUri) {
  const response = await fileApi.requestDownload(token, fileUri);
  return URL.createObjectURL(response.data);
}
